module.exports = __webpack_public_path__ + "img/9.c5b6acb2.jpg";